import type { HttpClient } from '@wix/cli-http-client';
import pRetry from 'p-retry';
import type { Options } from 'p-retry';
import { CliError, CliErrorCode } from '@wix/cli-error';
import { getTestOverrides } from '@wix/cli-test-overrides';
import { createProject } from '@wix/ambassador-codestore-v1-project/http';
import { GitRemoteType } from '@wix/ambassador-codestore-v1-project/types';
import { CreateProjectResponseSchema } from './schemas.js';

const { minRetryTimeout } = getTestOverrides();

export class CodestoreClient {
  private readonly retryOptions: Options;

  constructor(private readonly httpClient: HttpClient) {
    this.retryOptions = {
      retries: 3,
      minTimeout: minRetryTimeout,
      maxTimeout: 3 * 1000,
    };
  }

  createProject = async (
    projectId: string,
    userInfo: { name: string; email: string }
  ) => {
    try {
      const { data } = await pRetry(
        () =>
          this.httpClient.request(
            createProject({
              project: {
                id: projectId,
                gitRemoteType: GitRemoteType.S3,
                githubOptions: {
                  appId: 'b16d019c-d547-489b-a751-f277c1101847',
                  appInstallationId: '103037700',
                },
              },
              initialRevision: {
                id: '1',
                description: 'Initial revision',
                creationTime: new Date(),
                author: {
                  name: userInfo.name,
                  email: userInfo.email,
                },
              },
              files: [
                {
                  path: 'README.md',
                  content: 'Hello, Vibe!',
                },
              ],
            })
          ),
        this.retryOptions
      );

      return CreateProjectResponseSchema.parse(data).project;
    } catch (e) {
      throw new CliError({
        code: CliErrorCode.FailedToCreateCodestoreProject(),
        cause: e,
      });
    }
  };
}
